import React, { useState, useRef, useEffect, ForwardedRef } from 'react';

import Avatar from '@mui/material/Avatar';

import User from './interfaces/User';

import { useCacheContext } from './Contexts/FileCache';
import { SxProps, Theme, Tooltip } from '@mui/material';
import { useImperativeHandle } from 'react';

interface Props {
  user?: User;
  sx?: SxProps<Theme>;
  onClick?: (imageUrl: string | null) => void;
  [x: string]: any;
}

const UserAvatar = React.forwardRef((props: Props, ref: ForwardedRef<HTMLDivElement> | null) => {
  const { user, onClick, sx, ...propsLeft } = props;

  const internalRef = useRef<HTMLDivElement>(null);

  useImperativeHandle(ref, () => internalRef.current as HTMLDivElement);

  const { fetchFile } = useCacheContext();

  const [source, setSource] = useState<string | undefined>(undefined);

  const hasImage = useRef(false);

  useEffect(() => {
    console.log('avatar effect');
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting && internalRef.current) {
        observer.unobserve(internalRef.current); // Stop observing after loading

        console.log('observed!!!');

        if (user?.photo) {
          //      setSource(`/api/users/photo/${photoId}`);
          fetchFile(`/api/users/photo/${user.photo}`, 'low').then(ret => setSource(ret));
        }
      }
    }, { rootMargin: '50px' }); // Preload 50px before it enters view

    if (internalRef.current) observer.observe(internalRef.current);

    return () => observer.disconnect();
  }, [user]);
  /*
  useEffect(() => {
    setSource(undefined);

    if (photoId) {
//      setSource(`/api/users/photo/${photoId}`);
      fetchFile(`/api/users/photo/${photoId}`).then(ret => setSource(ret));
    }
  }, [photoId]);
  */


  const handleClick = () => {
    onClick?.(hasImage.current && source ? source : null);
  }
  /*
    useEffect(()=> {
      const controller = new AbortController();
  
      axios.get(`/api/users/${id}/photo`, { signal: controller.signal, responseType: 'blob'})
      .then(res => {
        setSource(URL.createObjectURL(res.data));
      })
      .catch(err => {
        setSource('/null');
      });
  
      return () => {
        controller.abort();
      }    
    }, [id]);
    */

  const name = user?.name ?? 'Guest';

  const stringToColor = (string: string) => {
    let hash = 0;
    let i;

    /* eslint-disable no-bitwise */
    for (i = 0; i < string.length; i += 1) {
      hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = '#';

    for (i = 0; i < 3; i += 1) {
      const value = (hash >> (i * 8)) & 0xff;
      color += `00${value.toString(16)}`.slice(-2);
    }
    /* eslint-enable no-bitwise */

    return color;
  }

  const newSx = { ...sx, backgroundColor: stringToColor(name), cursor: 'pointer' };
  const childProps = { sx: newSx, ...propsLeft };

  const handleLoaded = () => {
    hasImage.current = true;
  }

  const initial = name.split(' ').map(x => x.slice(0, 1)).join('').toUpperCase().slice(0, 2);

  return (
    <Tooltip title={name}>
      <Avatar ref={internalRef} alt={name} src={source} onClick={handleClick} imgProps={{ onLoad: handleLoaded, loading: 'lazy' }} {...childProps}>
        <span style={{ fontWeight: 'bold' }}>{initial}</span>
      </Avatar>
    </Tooltip>
  );
});

export default UserAvatar;
